// Pure view helpers for the guide detail screen.

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})(?:T00:00:00(?:\.000)?Z)?$/;

// DATE columns arrive as "YYYY-MM-DD" or UTC midnight; parsing them as UTC shows the previous day in
// timezones west of UTC, so they are rebuilt as a local calendar day.
export function parseDisplayDate(value) {
  if (!value) return null;
  if (value instanceof Date) return Number.isNaN(value.getTime()) ? null : value;
  const dateOnly = DATE_ONLY_PATTERN.exec(String(value).trim());
  const date = dateOnly
    ? new Date(Number(dateOnly[1]), Number(dateOnly[2]) - 1, Number(dateOnly[3]))
    : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

const normalizePartyName = (value) => String(value || '')
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '')
  .toLowerCase()
  .replace(/\s+/g, ' ')
  .trim();

export function isSameParty(left, right) {
  const a = normalizePartyName(left);
  return Boolean(a) && a === normalizePartyName(right);
}

const hasValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';

export function splitTransportFields(items = []) {
  return {
    assigned: items.filter((item) => hasValue(item.value)),
    pending: items.filter((item) => !hasValue(item.value)).map((item) => item.label),
  };
}

const EMISSION_EVENT_TYPES = new Set(['GUIA_EMITIDA', 'EMITIDA']);

// Guides emitted before the emission trace existed still show where their history starts.
export function withEmissionEvent(events = [], guia) {
  if (events.some((event) => EMISSION_EVENT_TYPES.has(String(event?.tipo || '').toUpperCase()))) return events;
  const emittedAt = guia?.created_at || guia?.fechaEmision || guia?.fecha_emision || null;
  if (!emittedAt) return events;
  return [
    ...events,
    {
      id: `emision-${guia?.id ?? 'guia'}`,
      tipo: 'GUIA_EMITIDA',
      estado: 'EMITIDA',
      descripcion: 'Registro de la emisión de la guía.',
      created_at: emittedAt,
      synthetic: true,
    },
  ];
}
